module.exports = __webpack_public_path__ + "img/classroom_bg_watercolor.12ab3994.png";